import Vue from 'vue';
import Vuex from 'vuex';

import login from './modules/login'

Vue.use(Vuex);
// 多个组件共享的数据或者用户状态，token之类的才走vuex管理

// const store = new Vuex.store({
//     state:{
//         name:'helloVueX'
//     },
//     mutations:{
//         //es6语法，等同edit:funcion(){...}
//         edit(state){
//             state.name = 'jack'
//         }
//     }
// })

// export default store

// // 方式一
// const login = new Vuex.Store({
//   state: {
//     staus: '0',
//     data: {}
//   },
//   actions: {
//     login_up(context, loaddata) {
//       console.log(loaddata);
//       return new Promise((resolve, reject) => {
//         console.log(loaddata);


//         resolve('1')
//       })
//     }
//   }
// });

// export default login;

// 对应调用方法
// this.$store.dispatch("login_up",{参数});

// const login = {
//   namespaced:true,
//   state: {
//     staus: '0',
//     data: {}
//   },
//   actions: {
//     login_up(context, loaddata) {
//       console.log(loaddata);
//       return new Promise((resolve, reject) => {
//         console.log(loaddata);


//         resolve('1')
//       })
//     }
//   }
// }

export default new Vuex.Store({
  modules: {
    login
  },
})
// store.state.a // -> moduleA 的状态
// store.state.b // -> moduleB 的状态
